module.exports = __webpack_public_path__ + "static/media/navigationButton.a542715e.svg";